import { http } from '@pendo/http';

export function formatChurnRate (churnRate) {
    return churnRate < 50 ? churnRate.toFixed(1) : churnRate;
}

export function getAllFocusGroups () {
    return http.get('/api/s/_SID_/insightssegment').then((res) => res.data);
}

export async function saveInsightsSegment ({ appId, segment }) {
    const { data } = await http.post('/api/s/_SID_/insightssegment', {
        appId,
        ...segment,
    });

    return data;
}

export function triggerMLPipeline ({ appId, insightsSegmentId }) {
    return http.post('/api/s/_SID_/insights/pipeline/trigger', { appId, insightsSegmentId });
}

export async function deleteInsightsSegmentById (segmentId, appId) {
    return http.delete(`api/s/_SID_/application/${appId}/insightssegment/${segmentId}`);
}

export async function getInsightsSegmentAppIds () {
    return http.get('/api/s/_SID_/insightssegment/apps').then((res) => res.data);
}
